import Cookies from "js-cookie";
import { CONSENT_EXPIRY_DAYS, COOKIE_NAME, type CookieConsent } from "@/types/cookie-consent";

/**
 * Cookie同意データの保存
 * Cookie + LocalStorageの両方に保存（冗長化）
 */
export function saveConsent(consent: CookieConsent): void {
  const consentData = JSON.stringify(consent);

  // Cookie に保存
  Cookies.set(COOKIE_NAME, consentData, {
    expires: CONSENT_EXPIRY_DAYS,
    sameSite: "Lax",
    secure: window.location.protocol === "https:", // HTTPSのみでsecure有効
  });

  // LocalStorage に保存
  try {
    localStorage.setItem(COOKIE_NAME, consentData);
  } catch (error) {
    console.warn("[Cookie] LocalStorage保存失敗:", error);
  }
}

/**
 * Cookie同意データの読み込み
 * 優先順位: Cookie > LocalStorage
 */
export function loadConsent(): CookieConsent | null {
  // Cookie から読み込み
  const cookieData = Cookies.get(COOKIE_NAME);
  if (cookieData) {
    try {
      return JSON.parse(cookieData) as CookieConsent;
    } catch (error) {
      console.warn("[Cookie] Cookie パースエラー:", error);
    }
  }

  // LocalStorage から読み込み
  try {
    const localData = localStorage.getItem(COOKIE_NAME);
    if (localData) {
      return JSON.parse(localData) as CookieConsent;
    }
  } catch (error) {
    console.warn("[Cookie] LocalStorage パースエラー:", error);
  }

  return null;
}

/**
 * Cookie同意の有効期限チェック
 */
export function isConsentExpired(consent: CookieConsent): boolean {
  return Date.now() > consent.expiresAt;
}

/**
 * Cookie同意のバージョンチェック
 */
export function isConsentVersionOutdated(consent: CookieConsent, currentVersion: string): boolean {
  return consent.version !== currentVersion;
}

/**
 * Cookie同意のリセット
 */
export function resetConsent(): void {
  Cookies.remove(COOKIE_NAME);
  try {
    localStorage.removeItem(COOKIE_NAME);
  } catch (error) {
    console.warn("[Cookie] LocalStorage削除失敗:", error);
  }
}
